
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/guild/gift",
      function () {
        return require("private-next-pages/[locale]/guild/gift/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/guild/gift"])
      });
    }
  